import { type CommonProps, type EventWithCount, ONBOARDING_EVENTS, trackEvent } from "."

// Activities events
export const activities = {
  landOnAddActivities: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.LAND_ADD_ACTIVITIES, props),
  goBackToWork: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.ACTIVITIES_GO_BACK, props),
  haveOtherActivities: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.HAVE_OTHER_ACTIVITIES, props),
  haveNotActivities: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.HAVE_NOT_ACTIVITIES, props),
  selectActivityTitle: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.SELECT_ACTIVITY_TITLE, props),
  writeActivityTitle: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.WRITE_ACTIVITY_TITLE, props),
  addEvent: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.ADD_ACTIVITY_EVENT, props),
  removeEvent: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.REMOVE_ACTIVITY_EVENT, props),
  keepSaving: (props: EventWithCount<"activitiesEventsCount">) =>
    trackEvent(ONBOARDING_EVENTS.KEEP_SAVING_ACTIVITY_EVENTS, props),
}
